import * as Long from "long";
import { selectBalancingPackageById } from "../balancingSelectors/selectBalancingPackages";
import { selectPlayerProfilePictureName } from "../balancingSelectors/selectBalancingPictures";
import { selectResourceAmountInfo } from "../balancingSelectors/selectBalancingResources";
import { IdDoghouseTreatPackage } from "../features/doghouse/IdDoghouseTreatPackage";
var UtilPackage = /** @class */ (function () {
    function UtilPackage() {
        var _this = this;
        this.setPackages = function (packageMap, packageIdToType, packages) {
            packages.map(function (currentPackage) {
                var currentPackageType = currentPackage.type
                    ? currentPackage.type
                    : undefined;
                if (currentPackageType !== undefined) {
                    if (!packageMap.has(currentPackageType)) {
                        packageMap.set(currentPackageType, new Map());
                    }
                    packageMap.get(currentPackageType).set(currentPackage.id, currentPackage);
                    packageIdToType.set(currentPackage.id, currentPackageType);
                }
            });
        };
        this.isPackageChest = function (packageInfo, packageId) {
            return packageInfo.id === packageId;
        };
        this.isPackageDogTreat = function (packageId) {
            return (packageId === IdDoghouseTreatPackage.Standard ||
                packageId === IdDoghouseTreatPackage.Premium);
        };
        this.packageIdToDisplayableItems = function (packageId) {
            var foundPackage = selectBalancingPackageById(packageId);
            if (foundPackage == undefined) {
                return [];
            }
            return _this.packageToDisplayableItems(foundPackage);
        };
        this.packageToDisplayableItems = function (balancingPackage) {
            var pictures = (balancingPackage.pictureReward || []).map(_this.pictureRewardToDisplayableItems);
            var items = (balancingPackage.resourceReward || []).map(_this.resourceRewardToDisplayableItems);
            return pictures.concat(items);
        };
        this.balloonRewardToGameItems = function (balloonReward) {
            var pictures = (balloonReward.pictureReward || []).map(_this.pictureRewardToDisplayableItems);
            var items = (balloonReward.resourceReward || []).map(_this.resourceRewardToDisplayableItems);
            return pictures.concat(items);
        };
        this.pictureRewardToDisplayableItems = function (pictureReward) {
            var picture = selectPlayerProfilePictureName(pictureReward.pictureId);
            return {
                amount: Long.fromValue(pictureReward.amount),
                profilePicture: {
                    id: pictureReward.pictureId,
                    src: picture,
                },
            };
        };
        this.resourceRewardToDisplayableItems = function (reward) {
            var rewardAsResource = selectResourceAmountInfo(reward.resourceId, reward.amount);
            return {
                amount: Long.fromValue(reward.amount),
                resource: rewardAsResource,
            };
        };
    }
    return UtilPackage;
}());
export var utilPackage = new UtilPackage();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilPackage.ts
// module id = 350
// module chunks = 3